// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1kqsD","column":"style_column__3Uqu7","row":"style_row__3sHNq"};